import { FrequencyRepeats, FrequencyStarting, FrequencyAt } from './components/frequency';
import Recipients from './components/Recipients';

import { find, isEmpty } from 'lodash';
import moment from 'moment';

const repeatsOptions = [
  { label: 'Daily', value: 'DAILY', text: 'day' },
  { label: 'Weekly', value: 'WEEKLY', text: 'week' },
  { label: 'Monthly', value: 'MONTHLY', text: 'month' }
];

const weekdaysOptions = [
  {
    label: 'Mon',
    value: 'MON'
  },
  {
    label: 'Tue',
    value: 'TUE'
  },
  {
    label: 'Wed',
    value: 'WED'
  },
  {
    label: 'Thu',
    value: 'THU'
  },
  {
    label: 'Fri',
    value: 'FRI'
  },
  {
    label: 'Sat',
    value: 'SAT'
  },
  {
    label: 'Sun',
    value: 'SUN'
  }
];

export const frequencyComponentsMap = {
  REPEAT: FrequencyRepeats,
  FREQUENCYAT: FrequencyAt,
  FREQUENCYSTARTINGFROM: FrequencyStarting
};

export const translateSchedule = schedule => {
  let schedules = [
    {
      componentType: 'REPEAT',
      title: 'Repeat',
      value: {},
      repeatsOptions,
      weekdaysOptions
    },
    {
      componentType: 'FREQUENCYAT',
      title: 'At',
      value: ''
    },
    {
      componentType: 'FREQUENCYSTARTINGFROM',
      title: 'Starting from',
      value: ''
    }
  ];

  if (!isEmpty(schedule)) {
    const { repeat, occurrence, repeatAt, startingFrom, daysOfWeek } = schedule;

    let frequencyRepeat = find(schedules, { title: 'Repeat' });

    const weekdays = daysOfWeek ? daysOfWeek.split(',') : [];
    frequencyRepeat.value = {
      repeat,
      occurrence,
      weekdays
    };

    let frequencyAt = find(schedules, { title: 'At' });
    frequencyAt.value = moment(repeatAt, 'HH:mm:ss'); // 22:00

    let frequencyStartingFrom = find(schedules, { title: 'Starting from' });
    frequencyStartingFrom.value = moment(startingFrom, 'YYYY-MM-DD'); // 2016-12-30
  }

  return schedules;
};

export const validateFrequency = filters => {
  for (const filter of filters) {
    const { value } = filter;

    if (!value) return false;
    if (typeof value === 'object' && Object.keys(value).length === 0) {
      return false;
    }

    if (filter.title === 'Repeat') {
      const repeat = filter.value;

      if (repeat.repeat === 'WEEKLY') {
        if (!repeat.weekdays || repeat.weekdays.length === 0) {
          return false;
        }
      }
    }
  }

  return true;
};

export const formatSchedule = (schedules, recipients) => {
  if(schedules.length == 0) return null;
  if (validateFrequency(schedules)) {
    let frequencyRepeat = find(schedules, { title: 'Repeat' }).value;
    let frequencyAt = find(schedules, { title: 'At' }).value;
    let frequencyStartingFrom = find(schedules, { title: 'Starting from' }).value;

    let schedule = {
      repeat: frequencyRepeat.repeat,
      occurrence: frequencyRepeat.occurrence,
     repeatAt: moment(frequencyAt).format('HH:mm').toString(),
      startingFrom: moment(frequencyStartingFrom).format('YYYY-MM-DD').toString(),
      recipientToAddress: recipients.to.toString(),
      recipientCCAddress: recipients.cc.toString(),
      recipientBCCAddress: recipients.bcc.toString()
    };

    if (frequencyRepeat.repeat === 'WEEKLY') {
      schedule.daysOfWeek = frequencyRepeat.weekdays.toString();
    }

    return schedule;
  } else {
    return null;
  }
};



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/report-edit/schedule.js